import { render } from "./WriterDialog.vue?vue&type=template&id=4aeb740a&scoped=true"
import script from "./WriterDialog.vue?vue&type=script&lang=js"
export * from "./WriterDialog.vue?vue&type=script&lang=js"

import "./WriterDialog.vue?vue&type=style&index=0&id=4aeb740a&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aeb740a"]])

export default __exports__